// Predefined colors for sections based on section ID
export const getSectionColor = (sectionId: number) => {
  const colors = [
    { bg: 'bg-blue-50', border: 'border-blue-200', text: 'text-blue-700', icon: 'text-blue-600' },
    { bg: 'bg-green-50', border: 'border-green-200', text: 'text-green-700', icon: 'text-green-600' },
    { bg: 'bg-purple-50', border: 'border-purple-200', text: 'text-purple-700', icon: 'text-purple-600' },
    { bg: 'bg-orange-50', border: 'border-orange-200', text: 'text-orange-700', icon: 'text-orange-600' },
    { bg: 'bg-pink-50', border: 'border-pink-200', text: 'text-pink-700', icon: 'text-pink-600' },
    { bg: 'bg-indigo-50', border: 'border-indigo-200', text: 'text-indigo-700', icon: 'text-indigo-600' },
    { bg: 'bg-red-50', border: 'border-red-200', text: 'text-red-700', icon: 'text-red-600' },
    { bg: 'bg-yellow-50', border: 'border-yellow-200', text: 'text-yellow-700', icon: 'text-yellow-600' },
    { bg: 'bg-teal-50', border: 'border-teal-200', text: 'text-teal-700', icon: 'text-teal-600' },
    { bg: 'bg-cyan-50', border: 'border-cyan-200', text: 'text-cyan-700', icon: 'text-cyan-600' },
  ];
  
  return colors[sectionId % colors.length];
};

// Get icon and label for data types
export const getDataTypeInfo = (type: 'data' | 'número' | 'texto' | 'categoria_mercado' | 'yesno' | 'status_prospeccao' | 'status_industria' | 'percent' | 'distributors' | 'distributors_count') => {
  switch (type) {
    case 'data':
      return {
        icon: '📅',
        label: 'Data',
        color: 'text-blue-600',
        bgColor: 'bg-blue-100'
      };
    case 'número':
      return {
        icon: '🔢',
        label: 'Número',
        color: 'text-green-600',
        bgColor: 'bg-green-100'
      };
    case 'texto':
      return {
        icon: '📝',
        label: 'Texto',
        color: 'text-purple-600',
        bgColor: 'bg-purple-100'
      };
    case 'categoria_mercado':
      return {
        icon: '🏪',
        label: 'Categoria',
        color: 'text-orange-600',
        bgColor: 'bg-orange-100'
      };
    case 'yesno':
      return {
        icon: '✅',
        label: 'Sim/Não',
        color: 'text-teal-600',
        bgColor: 'bg-teal-100'
      };
    case 'status_prospeccao':
      return {
        icon: '🔍',
        label: 'Status Prospecção',
        color: 'text-indigo-600',
        bgColor: 'bg-indigo-100'
      };
    case 'status_industria':
      return {
        icon: '🏭',
        label: 'Status Indústria',
        color: 'text-cyan-600',
        bgColor: 'bg-cyan-100'
      };
    case 'distributors':
      return {
        icon: '🏭',
        label: 'Distribuidores',
        color: 'text-cyan-600',
        bgColor: 'bg-cyan-100'
      };
    case 'distributors_count':
      return {
        icon: '🏭',
        label: 'Distribuidores',
        color: 'text-cyan-600',
        bgColor: 'bg-cyan-100'
      };
    case 'percent':
      return {
        icon: '📊',
        label: 'Porcentagem',
        color: 'text-emerald-600',
        bgColor: 'bg-emerald-100'
      };
    default:
      return {
        icon: '❓',
        label: 'Desconhecido',
        color: 'text-gray-600',
        bgColor: 'bg-gray-100'
      };
  }
};